"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// aws template names
var AWSTemplates;
(function (AWSTemplates) {
    AWSTemplates["resetPassword"] = "recoveryEmail";
})(AWSTemplates = exports.AWSTemplates || (exports.AWSTemplates = {}));
//# sourceMappingURL=index.js.map